export default "__VITE_ASSET__7bb98dbf__"